const GA_MEASUREMENT_ID = 'G-94BEXV271Y'

let initialized = false

declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

export function initGoogleAnalytics() {
  if (initialized || typeof window === 'undefined') return

  try {
    // Inject gtag.js script into <head> exactly as Google specifies
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)

    // Inject inline config script into <head>
    const inlineScript = document.createElement('script')
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `
    document.head.appendChild(inlineScript)

    // Also set on window for our helper functions
    window.dataLayer = window.dataLayer || []
    window.gtag = function () {
      window.dataLayer.push(arguments)
    }

    initialized = true
    console.log('✅ Google Analytics initialized:', GA_MEASUREMENT_ID)
  } catch (e) {
    console.error('❌ Google Analytics init error:', e)
  }
}

export function trackGAPageView(pagePath?: string, pageTitle?: string) {
  try {
    if (initialized && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: pagePath,
        page_title: pageTitle,
      })
    }
  } catch {
    // Silently fail
  }
}

export function trackGAEvent(eventName: string, params?: Record<string, any>) {
  try {
    if (initialized && window.gtag) {
      window.gtag('event', eventName, params)
    }
  } catch {
    // Silently fail
  }
}

// Common event helpers
export const gaEvents = {
  signUp: (method?: string) => {
    trackGAEvent('sign_up', { method })
  },

  login: (method?: string) => {
    trackGAEvent('login', { method })
  },

  beginCheckout: (value?: number, currency?: string) => {
    trackGAEvent('begin_checkout', { value, currency })
  },

  purchase: (transactionId: string, value: number, currency: string) => {
    trackGAEvent('purchase', {
      transaction_id: transactionId,
      value,
      currency,
    })
  },

  viewItem: (itemName?: string) => {
    trackGAEvent('view_item', { item_name: itemName })
  },

  generateLead: () => {
    trackGAEvent('generate_lead')
  },
}
